// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4e2c3ac5a0fb2eca9dbd","655":"818e4c5688ae147d262a"}[chunkId] + ".js";
};